/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Backdrop from '../Backdrop';
import classes from './SideDrawer.module.css';

const SideDrawer = ({ isOpen, onRequestClose, from, width, children }) => {
  let drawerClasses;
  if (from === 'right') {
    drawerClasses = isOpen ? [classes.sidedrawerRight, classes.open] : [classes.sidedrawerRight];
  } else {
    drawerClasses = isOpen ? [classes.sidedrawerLeft, classes.open] : [classes.sidedrawerLeft];
  }

  return (
    <React.Fragment>
      {isOpen && <Backdrop onBackdropClick={onRequestClose} />}
      <div className={drawerClasses.join(' ')} style={{ width: width }}>
        {children}
      </div>
    </React.Fragment>
  );
};

export default SideDrawer;

SideDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  from: PropTypes.oneOf(['left', 'right']),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SideDrawer.defaultProps = {
  isOpen: false,
  onRequestClose: () => { },
  from: 'left',
  width: '20vw',
};
